import React from 'react';
import { FadeIn } from './ui';
import { IMAGES } from './constants';
const FEATURES = [{
  icon: '🕐',
  title: 'Disponible cuando lo necesitás',
  desc: 'No importa si son las 3am o un domingo. La calidad no baja. Siempre hay alguien para escucharte.'
}, {
  icon: '🛡️',
  title: 'Sin juicios. Sin condicionamientos.',
  desc: 'A diferencia de hablar con alguien cercano, acá no hay historia previa. Valentín trabaja solo con lo que vos traés. Nada más.'
}, {
  icon: '🔐',
  title: 'Privacidad total. Siempre.',
  desc: 'Lo que hablás acá se queda acá. Sin excepciones. Podés mantener anonimato total si querés.'
}];
export function WhyEscuchaYA() {
  return <section className="w-full bg-[#1B2B4A] px-6 py-20 sm:py-28" data-id="element-112">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2" data-id="element-113">
        <div data-id="element-114">
          <FadeIn data-id="element-115">
            <h2 className="font-serif text-3xl text-white sm:text-4xl" data-id="element-116">
              Un espacio diferente a cualquier otro.
            </h2>
          </FadeIn>
          <div className="mt-10 space-y-8" data-id="element-117">
            {FEATURES.map((f, i) => <FadeIn key={f.title} delay={i * 0.08} data-id="element-118">
                <div className="flex gap-4" data-id="element-119">
                  <span className="text-2xl leading-none" aria-hidden="true" data-id="element-120">
                    {f.icon}
                  </span>
                  <div data-id="element-121">
                    <h3 className="font-serif text-xl text-white" data-id="element-122">{f.title}</h3>
                    <p className="mt-2 leading-relaxed text-white/70" data-id="element-123">
                      {f.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.1} className="order-first lg:order-last" data-id="element-124">
          <div className="overflow-hidden rounded-3xl border border-[#8BA3C7]/20" data-id="element-125">
            <img src={IMAGES.why} alt="Perfil de una persona en actitud contemplativa" className="h-full w-full object-cover" data-id="element-126" />
          </div>
        </FadeIn>
      </div>
    </section>;
}